<template>
  <DistributionTour />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DistributionTour from "@/components/Notes/Distribution/DistributionTour.vue";

export default defineComponent({
  name: "DistributionTourPage",
  components: {
    DistributionTour,
  },
});
</script>
